import React, { useEffect, useState } from "react";
import { CommonService } from "../../services/common/common.service";
import { useTranslation } from "react-i18next";
import { StatsProvider } from "../../store";
import StatisticsContent from "../../components/statistics-content/statistics-content.component";
import HeaderComponent from "../../components/header/header.component";
import { icons } from "../../statics/icons";
import { BuildingsService } from "../../services/buildings/buildings.service";
import { headerWithoutTableHeight } from "src/statics/header";

export default function StatisticsPage(props: any) {
  const commonService = new CommonService();
  const buildingsService = new BuildingsService();
  const buildingId = props.match.params.id;
  const empty: any = {
    name: "",
    address: "",
    city: "",
    postalCode: "",
  };
  const [building, setBuilding]: any = useState(empty);

  async function getBuildingDetails(buildingId: string) {
    const building = await buildingsService.getOneById(buildingId);
    setBuilding(building);
  }

  const [t] = useTranslation();
  useEffect(() => {
    const title = t("building details");
    commonService.setTitle(title);
    getBuildingDetails(buildingId);
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <HeaderComponent
        title={building.name}
        subtitle={
          building.address + ", " + building.postalCode + " " + building.city
        }
        icon={icons.homeIco}
        layout="half"
        headerHeight={headerWithoutTableHeight}
        displayMenu={true}
      />
      <StatsProvider>
        <StatisticsContent buildingId={buildingId} />
      </StatsProvider>
    </div>
  );
}
